import { applyMiddleware, createStore, compose } from 'redux';
import rootReducer from './reducers';
import thunkMiddleware from 'redux-thunk';

export default function configureStore(initialState, loggerMiddleware) {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [thunkMiddleware];

  // Add logger only in development mode && run start:logs
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_NO_REDUX_LOGS
  ) {
    middlewares.push(loggerMiddleware);
  }

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(rootReducer, () => {
      const nextRootReducer = require('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
